import http from '@/http';
import {
  AutocompleteResponse,
  AddressValidationResponse
} from '@/interfaces/admin/places';
import { AddressInterface } from '@/interfaces/admin/address';

export const autocomplete = async (query: string, sessionToken?: string): Promise<AutocompleteResponse> => {
  const res = await http.get('/places/autocomplete', {
    params: { q: query, ...(sessionToken && { sessionToken }) }
  });
  return res.data;
};

export const getPlaceDetails = async (placeId: string, sessionToken?: string): Promise<AddressInterface> => {
  const res = await http.get(`/places/${placeId}`, {
    params: { ...(sessionToken && { sessionToken }) }
  });
  return {
    ...res.data,
    placeId
  };
};

export const validate = async (address: AddressInterface, sessionToken?: string): Promise<AddressValidationResponse> => {
  const res = await http.post('/places/validate', address, {
    params: { ...(sessionToken && { sessionToken }) }
  });
  return res.data;
};
